// @flow
import React, {Component} from 'react';
import {isEmpty} from 'lodash';

import {Content as DestinationMessageContent} from './destinationMessage';

import type DestinationMessage from '@homeaway/graphql-traveler-urgency-messaging';
import {Alert} from '@homeaway/react-alerts';

import './SearchBanner.less';

type Props = {
    urgencyMessage?: DestinationMessage
};

export class SearchBannerContainer extends Component<Props> {
    render() {
        const {urgencyMessage} = this.props;

        let isUrgencyMessage =
            !isEmpty(urgencyMessage) &&
            (!isEmpty(urgencyMessage.iconTitleText) ||
                !isEmpty(urgencyMessage.iconText));

        let content;

        if (isUrgencyMessage) {
            content = <DestinationMessageContent {...urgencyMessage} />;
        }

        return content ? (
            <Alert
                dismissible={false}
                svgMarkup={null}
                flairClassName={null}
                className="SearchBanner"
                data-wdio="SearchBanner"
            >
                {content}
            </Alert>
        ) : null;
    }
}

export default SearchBannerContainer;
